import { render } from "./ManangeNews.vue?vue&type=template&id=7b304055&scoped=true"
import script from "./ManangeNews.vue?vue&type=script&lang=js"
export * from "./ManangeNews.vue?vue&type=script&lang=js"

import "./ManangeNews.vue?vue&type=style&index=0&id=7b304055&scoped=true&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b304055"]])

export default __exports__